<template>
    <button
        v-for="option in list"
        :key="option.value || option.color || option.label"
        :title="option.label"
        :aria-label="option.label"
        type="button"
        :class="[
            'w-[42px] h-[42px] shrink-0 flex items-center justify-center rounded-full bg-white relative',
            'focus:outline-none focus:ring-1 focus:ring-black ring-offset-4 hover:ring-1 hover:ring-black',
            {
                'ring-1 ring-black ring-offset-4': shouldShowCheckmark(option),
            }
        ]"
        @click="handleUpdateColorIsSelected(option)"
    >
        <color-swatch
            :color="option.color"
            :translucent="translucent"
        />
        <div
            v-if="shouldShowCheckmark(option)"
            :class="[
                'flex items-center justify-center rounded-full absolute pointer-events-none checkbox-visual',
                'w-6 h-6 bg-black bottom-[-8px] right-[-8px] border border-gray-light',
            ]"
        >
            <img
                src="../assets/images/icons/check-white.svg"
                width="12"
                height="12"
                class="pointer-events-none absolute"
                alt="Selected"
            />
        </div>
    </button>
</template>

<script>
    import ColorSwatch from './ColorSwatch.vue';

    export default {
        components: {
            ColorSwatch,
        },

        props: {
            list: Array,
            selectMode: String,
            selectedColor: String,
            translucent: {
                type: Boolean,
                default: false,
            },
        },

        emits: ['handleUpdateColorIsSelected'],

        methods: {
            handleUpdateColorIsSelected(option) {
                this.$emit('handleUpdateColorIsSelected', option);
            },

            shouldShowCheckmark(option) {
                // return this.selectMode === 'checkmark' && this.isAssociatedSubOptionColor(option);
                return this.isAssociatedSubOptionColor(option);
            },

            isAssociatedSubOptionColor(option) {
                if (!this.selectedColor || !option) {
                    return false;
                }

                const selectedColor = this.selectedColor.toLowerCase();

                return option.color?.toLowerCase() === selectedColor
                    || option.value?.toLowerCase() === selectedColor;
            },
        },
    };
</script>
